import * as React from "react";
import * as S from "@styled";
import CustomPopover from "shared/components/Popover";

import * as AppPath from "../model/AppPath";
import { IAgentGroupWithDisplayName, ProcessReferenceModel } from "../model/Process";
import styled from "styled-components";

const ShowIconOnHoverContainer = styled.div`
    i {
        visibility: hidden;
        /* display: none; */
    }
    &:hover i {
        visibility: visible;
    }
`

export const ProcessListArrayDisplay: React.FC<ArrayColumnDisplayProps> = (props) => {
    if (!props.processReferences || !props.processReferences.length) {
        return null;
    }

    function getPopoverContent(key: string, process: ProcessReferenceModel, agentGroup: IAgentGroupWithDisplayName) {
        return (
            <div key={"popup-array-display" + key}>
                <S.StyledLink variant={S.LinkTextColor.white} to={AppPath.getProcessPath(process.processId, process.isSubprocess, agentGroup.environmentName, agentGroup.agentGroupName)}>
                    {process.processName} - {process.processVersion} ({agentGroup.agentGroupDisplayName}) <i className="ci-external_link"></i>
                </S.StyledLink>
            </div>
        );
    }

    const popover = (
        <div id={props.processId + "-popover-" + props.columName}>
            <h3>{props.popoverTitle}</h3>
            {props.processReferences.map((v, index) =>
                v.map((process, processIndex) => {
                    return process.processName == null ?
                        <div key={"popup-array-display" + index + "" + processIndex} className="text-warning">{FRENDS.Localizations.SubprocessNotDeployed}: {process.processGuid}</div>
                        : process.agentGroupWithDisplayName.map((agentGroup, agentGroupIndex) =>
                            getPopoverContent(index + "" + processIndex + "" + agentGroupIndex, process, agentGroup));
                })
            )}
        </div>
    );

    return (
        <ShowIconOnHoverContainer>
            <CustomPopover
                tooltip={popover}
                clickHandlerStyles={{ cursor: "pointer" }}
            >
                <S.FlexContainer style={{ alignItems: "flex-end" }} gap={5}>
                    <span>
                        {/* Just take the first process name for the name array in the process list view. Usually process names do not change between versions*/}
                        {props.processReferences.map((process) => process[0].processName || process[0].processGuid).join(", ")}
                    </span>
                    <i className="ci-search_small_plus" />
                </S.FlexContainer>
            </CustomPopover>
        </ShowIconOnHoverContainer>
    );
};

export interface ArrayColumnDisplayProps {
    processId: number;
    columName: string;
    processReferences: ProcessReferenceModel[][];
    popoverTitle: string;
}

export const PromotedResultVariableDisplay: React.FC<{ promotedVariables: string[], processId: number }> = (props) => {
    if (!props.promotedVariables?.length) {
        return null;
    }

    const popover = (
        <div id={props.processId + "-popover-promotedVariable"}>
            <h4>Promoted result variables used in process</h4>
            {props.promotedVariables.map((promotedVariable) => <p key={promotedVariable}>{promotedVariable}</p>)}
        </div>
    );

    return (
        <CustomPopover
            tooltip={popover}
            clickHandlerStyles={{ cursor: "pointer" }}
        >
            <div className="showGlyphOnHover">
                <span style={{ width: 200 }} className="text-truncate-overflow">
                    {props.promotedVariables.join(", ")}
                </span>
                <i className="ci-search_small_plus" />
            </div>
        </CustomPopover>
    );
};
